import { BannerAspectRatio, StoreBodyBlock } from 'constants/enums';
import { z } from 'zod';

import { GradientDirection } from 'components/AcGradientInput/AcGraidentInput.types';
import {
  ETemplateStudioBundlesViewModel,
  ETemplateStudioLayoutOptions,
  EThemes
} from 'components/TemplatesStudio/enums';

const gradientSchema = z.object({
  colorOne: z.string().min(1, { message: 'Color is required.' }),
  colorTwo: z.string().optional(),
  gradientDirection: z.nativeEnum(GradientDirection).optional()
});

export const templateStudioSchema = z.object({
  templateName: z.string().min(1, { message: 'This field is required.' }),
  description: z.string(),
  tags: z.array(z.string()),
  bodyBlocksOrder: z.array(z.nativeEnum(StoreBodyBlock)),
  header: z.object({
    showPlayerName: z.boolean(),
    showPlayerId: z.boolean(),
    isSticky: z.boolean(),
    backgroundOpacity: z
      .number()
      .min(0, { message: 'Opacity must be at least 0%' })
      .max(100, { message: 'Opacity must be at most 100%' }),
    textColor: gradientSchema
  }),
  banner: z.object({
    selectedDesignId: z.string().nonempty('This field is required.')
  }),
  promotion: z.object({
    themes: z.array(z.nativeEnum(EThemes)),
    selectedDesignId: z.string().nonempty('This field is required.')
  }),
  bundle: z.object({
    offersPerRow: z.nativeEnum(ETemplateStudioBundlesViewModel).nullable(),
    bundleViewModel: z.nativeEnum(ETemplateStudioBundlesViewModel),
    themes: z.array(z.nativeEnum(EThemes)),
    selectedDesignId: z.string().nonempty('This field is required.')
  }),
  popup: z.object({
    popupRatio: z
      .nativeEnum(BannerAspectRatio)
      .refine((ratio) => ratio !== null, { message: 'This field is required.' })
  }),
  rollingOffers: z.object({
    desktopLayout: z.nativeEnum(ETemplateStudioLayoutOptions),
    themes: z.array(z.nativeEnum(EThemes)),
    selectedDesignId: z.string().nonempty('This field is required.')
  }),
  richText: z
    .object({
      text: z.string(),
      fontColor: z.string()
    })
    .optional(),
  dailyBonusBadge: z.object({
    selectedDesignId: z.string().nonempty('This field is required.')
  }),
  footer: z.object({
    showAppchargeLogo: z.boolean(),
    backgroundOpacity: z.number().min(0).max(100),
    textColor: gradientSchema
  })
});
